/**
 * Per-tab memory of the email typed on the login screen.
 *
 * The login flow leaves and re-enters the page in ways that destroy React
 * state — the full-document SSO redirect to an external IdP, the
 * /forgot-password route change, and ProtectedRoute redirect bounces — and
 * each of them used to cost the user a retyped email. sessionStorage survives
 * all of them while staying scoped to the tab; it is cleared as soon as a
 * session is established (and again on logout) so the address never outlives
 * the login flow on a shared machine.
 */
const LOGIN_EMAIL_KEY = 'login.email';
export function rememberLoginEmail(email) {
    try {
        sessionStorage.setItem(LOGIN_EMAIL_KEY, email);
    }
    catch {
        // Storage unavailable (privacy mode / quota) — the user retypes; never throw.
    }
}
export function recallLoginEmail() {
    try {
        return sessionStorage.getItem(LOGIN_EMAIL_KEY) ?? '';
    }
    catch {
        return '';
    }
}
export function clearLoginEmail() {
    try {
        sessionStorage.removeItem(LOGIN_EMAIL_KEY);
    }
    catch {
        // Storage unavailable — nothing was remembered anyway.
    }
}
